import { render, staticRenderFns } from "./TotalSubmissions.vue?vue&type=template&id=66851d44"
import script from "./TotalSubmissions.vue?vue&type=script&lang=js"
export * from "./TotalSubmissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports